import { useMutation } from "@tanstack/react-query";
import { axiosInstanceAuth } from "./client";
import { AxiosError } from "axios";
import { BaseResponse, ErrorResponse } from "interfaces";
import dayjs from "dayjs";

export const useAddSelfWash = (
  onOk?: (data: string) => void,
  onErr?: (error: AxiosError<ErrorResponse>) => void
) => {
  return useMutation<
    BaseResponse<string>,
    AxiosError<ErrorResponse>,
    { code: string }
  >({
    mutationKey: ["CREATE_EFC_LOG_BY_CUSTOMER_TAG_ID"],
    mutationFn: async ({ code }: { code: string }) =>
      axiosInstanceAuth.post(
        "/efc_logs",
        {
          version: 2.5,
          status: 1,
          data: {
            version: "2.5",
            event_name: "Came_Here",
            confidence: 1,
            device_code: "98",
            event_value: "1",
            section_code: "SP",
            location_code: "SP",
            customer_tag_id: code,
            edge_bridge_id: "WM0000000001",
            event_created_at: dayjs().valueOf(),
          },
        }
      ),
    onSuccess: (res) => {
      onOk && onOk(res.message);
    },
    onError: (err) => {
      onErr && onErr(err);
    },
  });
};